import { calculateDistance, rad2deg, deg2rad } from '../../../libraries/geometric';

export const dragVertex = function (state, e) {
    var coordinates = state.feature.coordinates[0].map(f => [...f]);
    coordinates = coordinates.concat(coordinates);

    var currentInd = parseInt(state.selectedCoordPaths[0].split('.')[1]);
    var inds = [currentInd - 2, currentInd - 1, currentInd, currentInd + 1]
        .map(f => f < 0 ? f + 4 : (f > 3 ? f - 4 : f));
    var zeroIndex = inds.indexOf(0);

    var startPoint = coordinates[inds[0]];
    var rectangle = [
        startPoint,
        [e.lngLat.lng, startPoint[1]],
        [e.lngLat.lng, e.lngLat.lat],
        [startPoint[0], e.lngLat.lat],
    ];
    state.feature.incomingCoords([rectangle.filter((_, ind) => ind >= zeroIndex).concat(rectangle.filter((_, ind) => ind <= zeroIndex))]);
}

export const moveFeature = (feature, constrainedDelta) => {
    var lngs = feature.coordinates[0].map(f => f[0]);
    var lats = feature.coordinates[0].map(f => f[1]);
    var minLng = lngs.min();
    var maxLng = lngs.max();
    var minLat = lats.min();
    var maxLat = lats.max();
    var halfLat = (minLat + maxLat) / 2;
    var oldLength = calculateDistance([minLng, halfLat], [maxLng, halfLat]);

    minLng += constrainedDelta.lng;
    maxLng += constrainedDelta.lng;
    minLat += constrainedDelta.lat;
    maxLat += constrainedDelta.lat;
    halfLat += constrainedDelta.lat;
    var newLength = calculateDistance([minLng, halfLat], [maxLng, halfLat]);

    var perRad = deg2rad((maxLng - minLng)) / newLength;

    // Fixing coordinates to match width
    var halfDeltaLength = rad2deg((oldLength - newLength) * perRad / 2);
    do {
        newLength = calculateDistance([minLng - halfDeltaLength, halfLat], [maxLng + halfDeltaLength, halfLat]);
        var delta = rad2deg(oldLength - newLength);
        halfDeltaLength += delta * perRad / 2;
        if (Math.abs(delta) < 0.00000001) break;
    } while (true); // eslint-disable-line 

    var rectangle = [
        [minLng - halfDeltaLength, maxLat],
        [maxLng + halfDeltaLength, maxLat],
        [maxLng + halfDeltaLength, minLat],
        [minLng - halfDeltaLength, minLat],
    ];
    feature.incomingCoords([[...rectangle, rectangle[0]]]);
};